// extracted by mini-css-extract-plugin
module.exports = {"dot":"_7c2253fa","activeDot":"_a85647f6"};